import React, { Component } from 'react';
import './Footer.css'

class Footer extends Component {
    render() {
        return (
            <div className="footer">
                {/* <div className="footer-message">
                    If you have any questions please email your Thales sales representative at <a href="mailto:sales@ssgl.com">support@thalesgroup.com</a>
                </div> */}
                <div className="footer-copyright">
                    © Copyright 2024 Thales
                </div>
            </div>
        )
    }
}

export default Footer;